import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import PolicyVehiclesDriversInfo from '../PA/PolicyVehiclesDriversInfo/PolicyVehiclesDriversInfo';
import PolicyDwellingInfo from '../HO/PolicyDwellingInfo/PolicyDwellingInfo';
import PolicyCommonCoverables from '../PolicyCommonCoverables/PolicyCommonCoverables';
import CommercialPropertyCoveragesInfo from '../CP/CommercialPropertyCoveragesComponent/CommercialPropertyCoveragesComponent';
import UmbrellaCoverageInfo from '../Umbrella/UmbrellaCoverages/UmbrellaCoverages';
import metadata from './PolicyCoverages.metadata.json5';
import PolicyMarineInfo from "../HO/PolicyMarineInfo/PolicyMarineInfo";

function PolicyCoverages(props) {
    const { value: policy } = props;

    if (_.isEmpty(policy)) {
        return null;
    }

    let umbrellaCoverables = undefined;
    if(policy.productName === 'Umbrella') {
        umbrellaCoverables = {
            coverables : policy.coverables,
            underlyingPolicies : policy.underlyingPolicies
        };
    }

    const policyUpdated = umbrellaCoverables !== undefined?  {...policy, umbrellaCoverables}: policy;

    const overrides = {
        policyVehiclesDriversInfoComponent: {
            visible: !_.isEmpty(policy.lobs.businessAuto)
        },
        policyCommercialVehiclesDriversInfoComponent : {
            visible:  !_.isEmpty(policy.lobs.commercialAuto)
        },

        policyHomeOwnersInfoComponent: {
            visible: !_.isEmpty(policy.lobs.homeOwners) && policy.productName !== 'Marine'
        },
        policyMarineInfoComponent: {
            visible: !_.isEmpty(policy.lobs.homeOwners) && policy.productName === 'Marine'
        },
        policyCommercialPropertyCoveragesContainer: {
            visible: !_.isEmpty(policy.lobs.commercialProperty)
        },
        umbrellaCoveragesComponent: {
            visible: umbrellaCoverables !== undefined
        },
        genericCoveragesComponent: {
            visible:
                _.isEmpty(policy.lobs.homeOwners)
                && _.isEmpty(policy.lobs.businessAuto)
                && _.isEmpty(policy.lobs.commercialAuto)
                && _.isEmpty(policy.lobs.commercialProperty)
                && !_.isEmpty(policy.coverables)
                && umbrellaCoverables === undefined
        }
    };

    const resolvers = {
        resolveComponentMap: {
            policyvehiclesdriversinfocomponent: PolicyVehiclesDriversInfo,
            policyCommercialVehiclesDriversInfoComponent:PolicyVehiclesDriversInfo,
            policydwellingcomponent: PolicyDwellingInfo,
            policymarinecomponent: PolicyMarineInfo,
            genericcoveragecomponent: PolicyCommonCoverables,
            commercialpropertycoveragecomponent: CommercialPropertyCoveragesInfo,
            umbrellacoveragecomponent: UmbrellaCoverageInfo
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyUpdated}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

PolicyCoverages.propTypes = {
    value: PropTypes.shape({})
};

PolicyCoverages.defaultProps = {
    value: {
        lobs: {
            homeOwners: {},
            personalAuto: {},
            commercialProperty: {},
            commercialAuto:{},
            coverables: []
        }
    }
};

export default PolicyCoverages;
